const sx = {
  wrapper: {
    width: '100%',
    minHeight: '100vh',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundImage: `url(/assets/images/auth-background.png)`,
    display: 'flex',
    flexDirection: 'column',
  },
};

export default sx;
